import {Component, OnInit, Input} from '@angular/core';
import {ProcedureThirteenService} from '../../services/procedures/procedure-thirteen.service';
import Swal, {SweetAlertIcon} from 'sweetalert2';

const moment = require('moment');
import {LocalDataSource} from 'ng2-smart-table';
import {environment} from '../../../environments/environment';
import {FilesService} from "../../services/files.service";

moment.locale('es');

@Component({
  selector: 'ngx-procedure-thirteen',
  templateUrl: './procedure-thirteen.component.html',
  styleUrls: ['./procedure-thirteen.component.scss'],
})
export class ProcedureThirteenComponent implements OnInit {
  @Input() stationId: any;
  state = 'Actividades';

  itemsSimulacrum = [
    {name: 'Fugas o derrame de combustible.', key: 'fugas'},
    {name: 'Choque de vehículo.', key: 'choque'},
    {name: 'Incendio y/o explosión en instalaciones.', key: 'incendioInstalaciones'},
    {name: 'Incendio de vehículos o transporte público.', key: 'incendioVehiculos'},
    {name: 'Explosión del compresor.', key: 'explosion'},
    {name: 'Asaltos', key: 'asaltos'},
    {name: 'Inundación', key: 'inundacion'},
    {name: 'Sismo', key: 'sismos'},
    {name: 'Granizo', key: 'granizo'},
    {name: 'Tormentas eléctricas', key: 'tormenta'},
    {name: 'Susceptibilidad de laderas', key: 'susceptibilidad'},
    {name: 'Sequias', key: 'sequias'},
    {name: 'Ondas Cálidas', key: 'ondas'},
    {name: 'Ciclones Tropicales', key: 'ciclones'},
    {name: 'Bajas Temperaturas', key: 'bajas'},
    {name: 'Nevadas', key: 'nevadas'},
  ];

  responsableOptions = [
    'Responsable de la estación de servicio',
    'Área de mantenimiento',
    'Responsable Técnico',
    'Responsable Personal de Mantenimiento',
    'Encargado de la estación de servicio',
  ];

  settings = {
    actions: false,
    columns: {
      simulacrum: {
        title: 'Simulacro',
        filter: true,
      },
      date: {
        title: 'Fecha',
        filter: true,
      },
      responsable: {
        title: 'Responsable',
        filter: false,
      },
      observations: {
        title: 'Observaciones',
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };

  source: LocalDataSource = new LocalDataSource;

  loading = false;

  simulacrumProgram = {
    simulacrum: { name: 'Fugas o derrame de combustible.', key: 'fugas' },
    responsable: 'Responsable de la estación de servicio',
    date: new Date(),
    observations: '',
  };

  documents = {
    programSimulacrum: '',
  };

  downloading = false;

  constructor(
    private procedureService: ProcedureThirteenService,
    private fileService: FilesService,
  ) {
  }

  async ngOnInit() {
    await this.getSimulacrumProgram();
    this.getDocuments();
  }

  onChangeTab(event: any) {
    this.state = event.tabTitle;
  }

  async getSimulacrumProgram() {
    this.loading = true;
    const [error, result]: any = await this.procedureService.getSimulacrumProgram(this.stationId);
    this.loading = false;
    if (error) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    const dataSource = [];
    for await (const item of result.data) await dataSource.push({
      simulacrum: item.simulacrum.name,
      date: moment(item.date).format('ll'),
      responsable: item.responsable,
      observations: item.observations,
    });
    await this.source.load(dataSource);
  }

  async saveSimulacrumProgram() {
    this.loading = true;
    const [error] = await this.procedureService.simulacrumProgram(this.stationId, this.simulacrumProgram);
    this.loading = false;
    if (error) return this.alert('Ha ocurrido un error, por favor intenta más tarde', 'error');
    this.alert('Programa de simulacros guardado con éxito');
    this.getSimulacrumProgram();
  }

  async getDocuments() {
    this.documents.programSimulacrum = `${environment.baseEndpoint}/filesGeneratorv2/implementation/thirteen/program/simulacrum/${this.stationId}`;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }
}
